import { useTaskEventStream } from '@backstage/plugin-scaffolder-react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import GavelIcon from '@material-ui/icons/Gavel';
import { useMatch } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    width: '100%',
    maxWidth: 960,
    padding: theme.spacing(2.5, 3),
    borderRadius: theme.shape.borderRadius * 2,
    border: `1px solid ${theme.palette.warning.light}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      textAlign: 'center',
    },
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
    },
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
}));

export const TaskBanner = () => {
  const match = useMatch('/create/tasks/:taskId');
  const taskId = match?.params.taskId;

  if (!taskId) return null;

  return <TaskBannerContent taskId={taskId} />;
};

const TaskBannerContent = ({ taskId }: { taskId: string }) => {
  const classes = useStyles();

  const taskStream = useTaskEventStream(taskId || '');
  const requestApprovalStatus = taskStream.steps['request-approval']?.status;
  const isApprovalPending = requestApprovalStatus === 'failed';

  if (!isApprovalPending) return null;

  return (
    <Box className={classes.wrapper}>
      <Paper className={classes.banner} elevation={0}>
        <Box className={classes.iconWrap}>
          <GavelIcon />
        </Box>
        <Box className={classes.body}>
          <Typography variant="subtitle1" className={classes.title}>
            Approval required
          </Typography>
          <Typography variant="body2" color="textSecondary">
            This task is paused and waiting for a reviewer. Approve it to resume
            the template execution.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};
